import dayjs from "dayjs";
import { Customer, Meeting } from "@acto/taskpane/core/domain";

// Dummy meetings shaped from the real domain types (Meeting carrying a full
// Customer). Replace with a meetings-with-full-customer query when the flow is
// wired to the backend.

interface DummyCustomerInput {
  id: string;
  externalReference: string;
  name: string;
  legacyId?: string;
  region?: string;
  branch?: string;
  group?: string;
  street?: string;
  industry?: string;
}

function makeCustomer(p: DummyCustomerInput): Customer {
  return new Customer(
    p.id,
    p.externalReference,
    p.name,
    p.legacyId,
    undefined, // domains
    p.region,
    p.branch,
    p.group,
    p.street,
    undefined, // postcode
    undefined, // city
    undefined, // country
    p.industry,
  );
}

function makeMeeting(id: string, date: string, time: string, customer: Customer): Meeting {
  return new Meeting(id, customer, dayjs(date), null, time);
}

const CUSTOMERS: DummyCustomerInput[] = [
  {
    id: "c1",
    externalReference: "KN-1450282",
    name: "Consortium, SAP WDF03 Restaurant, 69190 Walldorf",
    legacyId: "40820.54",
    region: "Berlin Nord",
    branch: "A+",
    group: "Fokuskunde",
    street: "Saarbrücker Str. 30",
    industry: "Minimarkt, Kiosk Trinkhallen",
  },
  {
    id: "c2",
    externalReference: "KN-2207419",
    name: "Bäckerei Hofmann GmbH, 10247 Berlin",
    legacyId: "31204.08",
    region: "Berlin Süd",
    branch: "B",
    group: "Stammkunde",
    street: "Wühlischstr. 12",
    industry: "Bäckerei, Konditorei",
  },
  {
    id: "c3",
    externalReference: "KN-0098231",
    name: "Edeka Markt Petersen, 24103 Kiel",
    legacyId: "55810.21",
    region: "Schleswig-Holstein",
    branch: "A",
    group: "Fokuskunde",
    street: "Holstenstr. 88",
    industry: "Lebensmitteleinzelhandel",
  },
  {
    id: "c4",
    externalReference: "KN-3341567",
    name: "Gastro Wieland & Sohn, 80331 München",
    legacyId: "27709.93",
    region: "Bayern Süd",
    branch: "C",
    group: "Neukunde",
    street: "Sendlinger Str. 45",
    industry: "Großküche, Catering",
  },
  {
    id: "c5",
    externalReference: "KN-1772044",
    name: "Tankstelle Nordstern, 28203 Bremen",
    legacyId: "60113.37",
    region: "Bremen",
    branch: "B+",
    group: "Stammkunde",
    street: "Friedrich-Ebert-Str. 9",
    industry: "Tankstelle, Shop",
  },
];

export const DUMMY_MEETINGS: Meeting[] = [
  makeMeeting("m1", "2026-05-22", "09:30", makeCustomer(CUSTOMERS[0])),
  makeMeeting("m2", "2026-05-22", "11:00", makeCustomer(CUSTOMERS[1])),
  makeMeeting("m3", "2026-05-22", "13:15", makeCustomer(CUSTOMERS[2])),
  makeMeeting("m4", "2026-05-22", "15:45", makeCustomer(CUSTOMERS[3])),
  makeMeeting("m5", "2026-05-22", "17:00", makeCustomer(CUSTOMERS[4])),
];
